import { Action } from '@ngrx/store';

export enum prodCommandActionType {
  SAVE_PRODCOMMAND = '[ProdCommand] save',
  REMOVE_PRODCOMMAND = '[ProdCommand] remove',
  ADDONE_PRODCOMMAND = '[ProdCommand] add_one',
  REMOVEONE_PRODCOMMAND = '[ProdCommand] remove_one',
  RESET_PRODCOMMAND= '[ProdCommand] reset_procommand',
  UPLOAD_PRODCOMMAND='[ProdCommand] upload_procommand',
  ACCEPT_ALL_PRODCOMMAND='[ProdCommand] accept_all',
  ACCEPT_NEW_PRODCOMMAND = '[ProdCommand] Accept New',
  UPDATE_PRODCOMMAND = '[ProdCommand] Update',
  REPLACE_ALL_PRODCOMMAND = '[ProdCommand] Replace All',
  UPDATE_STATUS_PRODCOMMAND = '[ProdCommand] Update Status'
}
export class SaveProdCommandAction implements Action {
  readonly type = prodCommandActionType.SAVE_PRODCOMMAND;

  //add an optional payload
  constructor(public payload: any) {}
}
export class UploadProdCommandAction implements Action {
  readonly type = prodCommandActionType.UPLOAD_PRODCOMMAND;
  //add an optional payload
  constructor(public payload: any) {}
}
export class RemoveProdCommandAction implements Action {
  readonly type = prodCommandActionType.REMOVE_PRODCOMMAND;
  //add an optional payload
  constructor(public payload: any) {}
}
export class AddOneProdCommandAction implements Action {
  readonly type = prodCommandActionType.ADDONE_PRODCOMMAND;
  //add an optional payload
  constructor(public payload: any) {}
}
export class RemoveOneProdCommandAction implements Action {
  readonly type = prodCommandActionType.REMOVEONE_PRODCOMMAND;
  //add an optional payload
  constructor(public payload: any) {}
}
export class ResetProdCommandAction implements Action {
  readonly type = prodCommandActionType.RESET_PRODCOMMAND;
  //add an optional payload
  constructor(public payload: any) {}
}
export class AcceptAllProdCommandAction implements Action {
  readonly type = prodCommandActionType.ACCEPT_ALL_PRODCOMMAND;
  //add an optional payload
  constructor(public payload: any) {}
}


export interface AcceptNewProdCommandAction {
  type: prodCommandActionType.ACCEPT_NEW_PRODCOMMAND;
  payload: {
    table: number;
  };
}

export interface UpdateProdCommandAction {
  type: prodCommandActionType.UPDATE_PRODCOMMAND;
  payload: {
    table: number;
    index: number;
    prod: any;
  };
}
export interface ReplaceAllProdCommandAction {
  type: prodCommandActionType.REPLACE_ALL_PRODCOMMAND;
  payload: {
    table: number;
    products: any[];
  };
}

export interface UpdateStatusProdCommandAction {
  type: prodCommandActionType.UPDATE_STATUS_PRODCOMMAND;
  payload: {
    table: number;
    lineId: string;
    status: string;
  };
}

export type CrudProdCommandAction = SaveProdCommandAction | RemoveProdCommandAction | AddOneProdCommandAction | RemoveOneProdCommandAction | ResetProdCommandAction | UploadProdCommandAction | AcceptAllProdCommandAction | AcceptNewProdCommandAction | UpdateProdCommandAction | ReplaceAllProdCommandAction | UpdateStatusProdCommandAction;